export default "__VITE_ASSET__B038_jHY__"